import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

const SignUpOfferPage = ({
	offerHeadline,
	offerContent,
	offerLink,
	buttonText,
	defaultBookmakerUrl,
	analyticsRegistrationClick,
}) => (
	<div
		className='root__bookmakersPopOverContentOfferBox'
		data-test-selector='Container__BookmakerSignUpOffer'
	>
		<h1
			className='root__bookmakersPopOverContentOfferHeadlineTextContent'
			data-test-selector='Text__BookmakerSignUpOfferHeadline'
		>
			{offerHeadline}
		</h1>
		<span
			className='root__bookmakersPopOverContentOfferContent'
			data-test-selector='Text__BookmakerSignUpOfferContent'
		>
			{offerContent}
		</span>
		<a
			href={offerLink || defaultBookmakerUrl}
			className='root__bookmakersPopOverContentOfferButton ui-btn'
			target='_blank'
			onClick={analyticsRegistrationClick}
			data-test-selector='Link__BookmakerSignUp'
			rel="noreferrer nofollow sponsored"
		>
			{buttonText}
		</a>
	</div>
);

SignUpOfferPage.propTypes = {
	offerHeadline: PropTypes.string.isRequired,
	offerContent: PropTypes.string.isRequired,
	offerLink: PropTypes.string.isRequired,
	buttonText: PropTypes.string.isRequired,
	defaultBookmakerUrl: PropTypes.string,
	analyticsRegistrationClick: PropTypes.func,
};

export default SignUpOfferPage;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/signUpOfferPage/signUpOfferPage.jsx